// Делаем простой аналог Vuex - нужно для интеграции ЛКИ в ипотечный калькулятор
export default {
	developersData: {},
	developersRegion: '',
	partnersRegion: '',
	gtm: ''
 }
